export default __webpack_public_path__ + "assets/a0912079fa6b02c9ba5e2958d8798b98.png";